import _ from "lodash";
import classes from "../IconSelector.scss";
import {
  BulbOutlined,
  AssessmentandEvaluationOutlined,
  CalculatorOutlined,
  PageSquareOutlined,
  ImageSquareOutlined,
  JournalOutlined,
  BooksTwoOutlined,
  BookStarOutlined,
  BadgeStarOutlined,
  BookmarkOutlined,
  ImageCollageOutlined,
  WorkbookOutlined,
  VideoOutlined,
  CodeOutlined,
  PlaceholderFileOutlined,
} from "@toddle-edu/ds-icons";

export const COLOR_MAPPING = {
  blue: {
    background: classes.blueBackground,
    icon: classes.blueColor,
    picker: classes.blueIconPicker,
  },
  pink: {
    background: classes.pinkBackground,
    icon: classes.pinkColor,
    picker: classes.pinkIconPicker,
  },
  violet: {
    background: classes.violetBackground,
    icon: classes.violetColor,
    picker: classes.violetIconPicker,
  },
  teal: {
    background: classes.tealBackground,
    icon: classes.tealColor,
    picker: classes.tealIconPicker,
  },
  yellow: {
    background: classes.yellowBackground,
    icon: classes.yellowColor,
    picker: classes.yellowIconPicker,
  },
  neutral: {
    background: classes.neutralBackground,
    icon: classes.neutralColor,
    picker: classes.neutralIconPicker,
  },
  purple: {
    background: classes.purpleBackground,
    icon: classes.purpleColor,
    picker: classes.purpleIconPicker,
  },
};

export const ICON_COMPONENTS = {
  BulbOutlined: BulbOutlined,
  AssessmentandEvaluationOutlined: AssessmentandEvaluationOutlined,
  CalculatorOutlined: CalculatorOutlined,
  PageSquareOutlined: PageSquareOutlined,
  ImageSquareOutlined: ImageSquareOutlined,
  JournalOutlined: JournalOutlined,
  BooksTwoOutlined: BooksTwoOutlined,
  BookStarOutlined: BookStarOutlined,
  BadgeStarOutlined: BadgeStarOutlined,
  BookmarkOutlined: BookmarkOutlined,
  ImageCollageOutlined: ImageCollageOutlined,
  WorkbookOutlined: WorkbookOutlined,
  VideoOutlined: VideoOutlined,
  CodeOutlined: CodeOutlined,
  PlaceholderFileOutlined: PlaceholderFileOutlined,
};

export const getIconClasses = backgroundColor => {
  if (_.includes(_.keys(COLOR_MAPPING), backgroundColor)) {
    const backgroundClass = COLOR_MAPPING[backgroundColor].background;
    const iconColorClass = COLOR_MAPPING[backgroundColor].icon;
    return { backgroundClass, iconColorClass };
  }
  return {
    backgroundClass: classes.yellowBackground,
    iconColorClass: classes.yellowColor,
  };
};

export const getSelectedIcon = icon => {
  if (_.includes(_.keys(ICON_COMPONENTS), icon)) {
    return ICON_COMPONENTS[icon];
  }
  return BulbOutlined;
};

export const IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "image/heic",
  "image/heif",
];

export const getRandomColor = () => {
  const colorList = _.keys(COLOR_MAPPING);
  return colorList[Math.floor(Math.random() * colorList.length)];
};

export const getRandomIcon = () => {
  const iconList = _.keys(ICON_COMPONENTS);
  return iconList[Math.floor(Math.random() * iconList.length)];
};
